import { render, staticRenderFns } from "./ForgotPasswordPTSI.vue?vue&type=template&id=c9f9c29a&scoped=true"
import script from "./ForgotPasswordPTSI.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordPTSI.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordPTSI.vue?vue&type=style&index=0&id=c9f9c29a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f9c29a",
  null
  
)

export default component.exports